import type { Companion, Player, Vec2 } from "./types";
import { confine } from "./rules";

export function formation(center: Vec2, slot: number): Vec2 {
  const angle = Math.PI * 0.15 + slot * Math.PI * 0.25,
    radius = 112 + (slot % 2) * 36;
  const target = {
    x: center.x + Math.cos(angle) * radius,
    y: center.y + Math.sin(angle) * radius,
  };
  confine(target, 35);
  return target;
}
/** 玩家具有通行权。对称重叠用稳定 ID 打破死锁，不用随机数制造抖动。 */
export function separate(
  companions: Companion[],
  player: Player | Companion,
  dt: number,
): void {
  // Social spacing follows the wide botanical bodies; combat collision radii stay independent.
  const space = (c: Companion) =>
    ["pumpkin", "wintermelon"].includes(c.cropId)
      ? 38
      : c.cropId === "coconut"
        ? 33
        : 26;
  for (let pass = 0; pass < 3; pass++)
    for (let i = 0; i < companions.length; i++) {
      const a = companions[i];
      if (a === player) continue;
      const repel = (
        other: Vec2,
        min: number,
        strength: number,
        seed: number,
      ): void => {
        let dx = a.pos.x - other.x,
          dy = a.pos.y - other.y,
          d = Math.hypot(dx, dy);
        if (d >= min) return;
        if (d < 0.01) {
          const angle = seed * 2.399963;
          dx = Math.cos(angle);
          dy = Math.sin(angle);
          d = 1;
        }
        const move = Math.min(min - d, 180 * dt) * strength;
        a.pos.x += (dx / d) * move;
        a.pos.y += (dy / d) * move;
      };
      repel(player.pos, player.radius + space(a) + 22, 1, a.id);
      const speed = Math.hypot(player.velocity.x, player.velocity.y);
      if (speed > 20)
        repel(
          {
            x: player.pos.x + (player.velocity.x / speed) * 40,
            y: player.pos.y + (player.velocity.y / speed) * 40,
          },
          48,
          0.6,
          a.id,
        );
      for (let j = 0; j < companions.length; j++)
        if (i !== j)
          repel(
            companions[j].pos,
            space(a) + space(companions[j]) + 10,
            0.5,
            a.id - j,
          );
      confine(a.pos);
    }
}
